module.exports = __webpack_public_path__ + "img/24000.18314433.jpg";